import { LitElement, html } from './-global.min.js'

class HHProductCardVariants extends LitElement {
  get anchor() {
    return this.querySelector('.js-anchor')
  }

  get variantButtons() {
    return [...this.querySelectorAll('.js-swatch')]
  }

  connectedCallback() {
    super.connectedCallback()
    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onClickHandler.bind(this))
    })

    this.productFormInput = this.closest('hh-product-form')?.querySelector(
      '.js-product-form-input'
    )

    if (window.location.href.includes('collections')) {
      this.initLinkClick()
    }

    this.gallery = this.querySelector('hh-swiper')
    this.secondSlideContent = this.gallery?.querySelector(
      '.swiper-slide:nth-child(2)'
    ).innerHTML

    if (this.gallery) {
      const resizeObserver = new ResizeObserver((entries) => {
        if (window.innerWidth >= 990) {
          this.removeSecondSlide()
        } else {
          this.addSecondSlide()
        }
      })

      resizeObserver.observe(this)
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onClickHandler)
    })
  }

  onClickHandler(event) {
    if (this.anchor) {
      this.anchor.href = event.target.dataset.variantUrl
    }
    this.handleProductFormId(event)
  }

  handleProductFormId(event) {
    if (!this.productFormInput) return
    const variantId = event.target.dataset.variantId

    if (variantId) {
      this.productFormInput.value = variantId
    }
  }

  initLinkClick() {
    const link = this.querySelector('[data-product-card-link]')

    link?.addEventListener('click', (e) => {
      if (
        !e.target.closest('a') ||
        e.target.classList.contains('swiper-button')
      )
        return
      const linkHasPageReference = e.target.closest(`[data-page]`)
      if (!linkHasPageReference) return true
      e.preventDefault()
      const updatedURL = new URL(window.location.href)
      if (linkHasPageReference.hasAttribute('id')) {
        updatedURL.hash = linkHasPageReference.getAttribute('id')
      }
      updatedURL.searchParams.set('page', linkHasPageReference.dataset.page)
      history.pushState({}, '', updatedURL.toString())
      window.location.href = linkHasPageReference.getAttribute('href')
    })
  }

  addSecondSlide() {
    if (!this.secondSlideRemoved) return
    const newSlide = document.createElement('div')
    newSlide.classList.add('swiper-slide')
    newSlide.innerHTML = this.secondSlideContent
    this.gallery.swiper.addSlide(1, newSlide)
    this.secondSlideRemoved = false
  }

  removeSecondSlide() {
    if (this.secondSlideRemoved) return
    this.gallery.swiper.removeSlide(1)
    this.gallery.swiper.update()
    this.gallery.swiper.slideTo(0, 0)
    this.secondSlideRemoved = true
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card-variants', HHProductCardVariants)
